import styled from 'styled-components'

export const Action = styled.div`
  display: flex;
  justify-content: center;
`

export const Wrapper = styled.div.attrs(() => ({
  className: 'table-responsive mt-4',
}))`
  overflow-y: auto;
  height: 550px;
`
